import { useCallback, useState } from "react";
import { FormState } from "../../../../shared/Enum";
import { createLocation } from "../../../../api/Locations/Repository";
import { CreateLocationDto } from "../../../../api/Locations/Dto/CreateLocationDto";
import { enqueueSnackbar } from "notistack";

interface Return {
  data: {
    formState: FormState;
  };
  method: {
    onCreateLocation(formData: CreateLocationDto): void;
  };
}

export default function useViewModel(): Return {
  const [formState, setFormState] = useState<FormState>(FormState.Idle);

  const onCreateLocation = useCallback(
    async (formData: CreateLocationDto) => {
      setFormState(FormState.Loading);
      await createLocation(formData)
        .then(() => {
          setFormState(FormState.Success);
          enqueueSnackbar("Location created successfully.", {
            variant: "success",
          });
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          setFormState(FormState.Error);
        });
    },
    [createLocation]
  );

  return {
    data: {
      formState,
    },
    method: { onCreateLocation },
  };
}
